import { Member } from "../pages/aboutus"
import moment from "moment"
// this page is static data that could've been served from the backend
// but taking a tech debt, to avoid development of the backend unless really needed

export interface Attr {
  rarity_pct: string
  trait_type: string
  value: string
  weight: number
}

export interface Creator {
  ownership: number
  stake_address: string
}

export interface NftImgUri {
  https: string // use pixel path if it's not released
  ipfs: string
}

export interface NftProps {
  attributes: Attr[]
  author: string
  category: string
  create_date: number
  creators: [Creator]
  description: string
  id: number
  image: string
  location: NftImgUri
  name: string
  rarity_per_mil: string
  seller_fee_basis_points: number
  sha256: string
  symbol: string
  type: string
  release_date?: number
  price?: number
}

const raw: NftProps[] = [
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489830239,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1u8zy8cj3377rtpjdc2u8kg8mxg9mc62tq97t2l2pa3f2w7s9ag8l3",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 1,
    image: "ipfs://roam_llama_1.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_1.png",
      ipfs: "ipfs://roam_llama_1.png",
    },
    name: "roam_llama_1.png",
    rarity_per_mil: "58.52927",
    seller_fee_basis_points: 200,
    sha256: "e7fa2517c76fd99131a7435698aa0fe59b9fece5b2d7adce737f28324ca323b7",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489835392,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 2,
    image: "ipfs://roam_llama_2.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_2.png",
      ipfs: "ipfs://roam_llama_2.png",
    },
    name: "roam_llama_2.png",
    rarity_per_mil: "2.20626",
    seller_fee_basis_points: 200,
    sha256: "53e14cb355e3beba934c0c267017e4db757848fb92769a5c0c535970f33689cf",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489839938,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 3,
    image: "ipfs://roam_llama_3.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_3.png",
      ipfs: "ipfs://roam_llama_3.png",
    },
    name: "roam_llama_3.png",
    rarity_per_mil: "3.42813",
    seller_fee_basis_points: 200,
    sha256: "f25f1703e26ceedff681a48c220742e36ab21b00b7e79d0c4003ca4369422936",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "5.60",
        trait_type: "earrings",
        value: "moonstars",
        weight: 3,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489847454,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 4,
    image: "ipfs://roam_llama_4.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_4.png",
      ipfs: "ipfs://roam_llama_4.png",
    },
    name: "roam_llama_4.png",
    rarity_per_mil: "0.91450",
    seller_fee_basis_points: 200,
    sha256: "5eddfd5c00b99647fb605377cabfde02caa28a6bf98e092068566b591b8beade",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "7.70",
        trait_type: "neckwear",
        value: "jewels",
        weight: 5,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489852134,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 5,
    image: "ipfs://roam_llama_5.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_5.png",
      ipfs: "ipfs://roam_llama_5.png",
    },
    name: "roam_llama_5.png",
    rarity_per_mil: "0.09978",
    seller_fee_basis_points: 200,
    sha256: "a48b40ce797e23ebedd164b46b825fd899ea6474aa6f006d96867e6ec7d50d0a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489856294,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 6,
    image: "ipfs://roam_llama_6.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_6.png",
      ipfs: "ipfs://roam_llama_6.png",
    },
    name: "roam_llama_6.png",
    rarity_per_mil: "18.18818",
    seller_fee_basis_points: 200,
    sha256: "88b9524363f564e549c9056592b24ecafddc2fd003dbca98d6344c0a4b6053c0",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489861471,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 7,
    image: "ipfs://roam_llama_7.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_7.png",
      ipfs: "ipfs://roam_llama_7.png",
    },
    name: "roam_llama_7.png",
    rarity_per_mil: "1.66958",
    seller_fee_basis_points: 200,
    sha256: "1ebbdc9f94acf7c259aa28591493e8a91f1c78f69a7de1d2e7352b77a12cfbc2",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489866274,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 8,
    image: "ipfs://roam_llama_8.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_8.png",
      ipfs: "ipfs://roam_llama_8.png",
    },
    name: "roam_llama_8.png",
    rarity_per_mil: "43.89941",
    seller_fee_basis_points: 200,
    sha256: "ee17e1d6218a2f1ab5cffa1ff41aae6b60add635ac606e23f598b362f340268e",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489873499,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 9,
    image: "ipfs://roam_llama_9.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_9.png",
      ipfs: "ipfs://roam_llama_9.png",
    },
    name: "roam_llama_9.png",
    rarity_per_mil: "39.81592",
    seller_fee_basis_points: 200,
    sha256: "ea941f93bfc40bc677b91098aad57ae6cee17ea2eded0986d59d9fd634cd2655",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489877525,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 10,
    image: "ipfs://roam_llama_10.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_10.png",
      ipfs: "ipfs://roam_llama_10.png",
    },
    name: "roam_llama_10.png",
    rarity_per_mil: "4.15461",
    seller_fee_basis_points: 200,
    sha256: "30291a40e1a50b58f36a41eacf75811cd8f8e2a2af01be96d00c017438c9985e",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489881815,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 11,
    image: "ipfs://roam_llama_11.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_11.png",
      ipfs: "ipfs://roam_llama_11.png",
    },
    name: "roam_llama_11.png",
    rarity_per_mil: "6.73683",
    seller_fee_basis_points: 200,
    sha256: "4225ecc80e0d4c69395d494a5d3fc3721d8f53917c135ca7492ac1b6031c3976",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489886341,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 12,
    image: "ipfs://roam_llama_12.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_12.png",
      ipfs: "ipfs://roam_llama_12.png",
    },
    name: "roam_llama_12.png",
    rarity_per_mil: "7.53040",
    seller_fee_basis_points: 200,
    sha256: "c798a2906f24e8b92e19b9bf11613315474a7915f062ecdec8ecf01c38609b18",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489893238,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 13,
    image: "ipfs://roam_llama_13.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_13.png",
      ipfs: "ipfs://roam_llama_13.png",
    },
    name: "roam_llama_13.png",
    rarity_per_mil: "5.36105",
    seller_fee_basis_points: 200,
    sha256: "70c1cfebf962029019a34f06a6a3818cdb607ed7875e53ec64678ff6a76c935e",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489897570,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 14,
    image: "ipfs://roam_llama_14.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_14.png",
      ipfs: "ipfs://roam_llama_14.png",
    },
    name: "roam_llama_14.png",
    rarity_per_mil: "36.62753",
    seller_fee_basis_points: 200,
    sha256: "73b702feec31ba524101cc7c49d97a3dd1580ffab9bf66eed7e871efd64a5bf7",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489902605,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 15,
    image: "ipfs://roam_llama_15.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_15.png",
      ipfs: "ipfs://roam_llama_15.png",
    },
    name: "roam_llama_15.png",
    rarity_per_mil: "3.89914",
    seller_fee_basis_points: 200,
    sha256: "746094c2ec765bc7b9ab91526cc3fc4012f96c64caf2c6c1716afb080ec5754b",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489907007,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 16,
    image: "ipfs://roam_llama_16.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_16.png",
      ipfs: "ipfs://roam_llama_16.png",
    },
    name: "roam_llama_16.png",
    rarity_per_mil: "22.40868",
    seller_fee_basis_points: 200,
    sha256: "c3304faf83640997451ee9a927162aa3c5e7526c8b17193bde47804f32a062e1",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489911210,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 17,
    image: "ipfs://roam_llama_17.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_17.png",
      ipfs: "ipfs://roam_llama_17.png",
    },
    name: "roam_llama_17.png",
    rarity_per_mil: "52.42850",
    seller_fee_basis_points: 200,
    sha256: "039e360cce5c5ce8b39f3f588721322688ac63f6e060cf4ee697c1c83b3f9a05",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489915624,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 18,
    image: "ipfs://roam_llama_18.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_18.png",
      ipfs: "ipfs://roam_llama_18.png",
    },
    name: "roam_llama_18.png",
    rarity_per_mil: "4.62901",
    seller_fee_basis_points: 200,
    sha256: "d355cd8d1a275f8ab01a0313cd3962fd84400660e5d53cde89b3963a7cd1154f",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489922396,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 19,
    image: "ipfs://roam_llama_19.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_19.png",
      ipfs: "ipfs://roam_llama_19.png",
    },
    name: "roam_llama_19.png",
    rarity_per_mil: "0.97048",
    seller_fee_basis_points: 200,
    sha256: "15fbc5ca36f3ae4fd122720b8b55e76d7bf4306d061a1af05993b94657b88e1a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489926977,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 20,
    image: "ipfs://roam_llama_20.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_20.png",
      ipfs: "ipfs://roam_llama_20.png",
    },
    name: "roam_llama_20.png",
    rarity_per_mil: "12.72900",
    seller_fee_basis_points: 200,
    sha256: "e253a8ac48fcddf3ce40da9d3f80ee774b0de354bb28d40fff294c37d6c0bd4e",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489931363,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 21,
    image: "ipfs://roam_llama_21.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_21.png",
      ipfs: "ipfs://roam_llama_21.png",
    },
    name: "roam_llama_21.png",
    rarity_per_mil: "3.00869",
    seller_fee_basis_points: 200,
    sha256: "90ae578f8a23f6d745533610fd21156186017a1e0f078d7bc1b66a4906db6492",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "7.70",
        trait_type: "neckwear",
        value: "jewels",
        weight: 5,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "3.40",
        trait_type: "earrings",
        value: "trees",
        weight: 2,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489935793,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 22,
    image: "ipfs://roam_llama_22.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_22.png",
      ipfs: "ipfs://roam_llama_22.png",
    },
    name: "roam_llama_22.png",
    rarity_per_mil: "0.44460",
    seller_fee_basis_points: 200,
    sha256: "ffc0d47ca0edab4098ce15a7e95d113d5d978f17775d40f55c599e8eb17fd911",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "7.70",
        trait_type: "neckwear",
        value: "jewels",
        weight: 5,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489940066,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 23,
    image: "ipfs://roam_llama_23.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_23.png",
      ipfs: "ipfs://roam_llama_23.png",
    },
    name: "roam_llama_23.png",
    rarity_per_mil: "9.10647",
    seller_fee_basis_points: 200,
    sha256: "98dba68a2c0742c90a8ae875ad40cb4e4443b4e304edd631f855602758fd6763",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489945060,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 24,
    image: "ipfs://roam_llama_24.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_24.png",
      ipfs: "ipfs://roam_llama_24.png",
    },
    name: "roam_llama_24.png",
    rarity_per_mil: "4.07399",
    seller_fee_basis_points: 200,
    sha256: "5d32f838724f4f0d336254b1562c0cd3fcce007573da3685dd06ceee544fae39",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489950281,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 25,
    image: "ipfs://roam_llama_25.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_25.png",
      ipfs: "ipfs://roam_llama_25.png",
    },
    name: "roam_llama_25.png",
    rarity_per_mil: "3.15967",
    seller_fee_basis_points: 200,
    sha256: "abeed3dcc49a44ba7c0627002c8878959e4556601732bb470859064c4d55c036",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "5.60",
        trait_type: "earrings",
        value: "moonstars",
        weight: 3,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489957533,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 26,
    image: "ipfs://roam_llama_26.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_26.png",
      ipfs: "ipfs://roam_llama_26.png",
    },
    name: "roam_llama_26.png",
    rarity_per_mil: "16.15044",
    seller_fee_basis_points: 200,
    sha256: "522a1e468f1a4f1f71dcc539c3f12dcc7ce322c466d11e34a86763dc8c9040f8",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "3.40",
        trait_type: "earrings",
        value: "trees",
        weight: 2,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489961754,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 27,
    image: "ipfs://roam_llama_27.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_27.png",
      ipfs: "ipfs://roam_llama_27.png",
    },
    name: "roam_llama_27.png",
    rarity_per_mil: "0.32995",
    seller_fee_basis_points: 200,
    sha256: "b7a75f3752ed88dbb3028c3f72635dc10c3b86922b59de7ca2bb89c0e55986a5",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489966218,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 28,
    image: "ipfs://roam_llama_28.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_28.png",
      ipfs: "ipfs://roam_llama_28.png",
    },
    name: "roam_llama_28.png",
    rarity_per_mil: "22.86996",
    seller_fee_basis_points: 200,
    sha256: "a81baf866702384b99ea753b1898da1762486d96aebc22c047e059f6c90b8adf",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489970634,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 29,
    image: "ipfs://roam_llama_29.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_29.png",
      ipfs: "ipfs://roam_llama_29.png",
    },
    name: "roam_llama_29.png",
    rarity_per_mil: "33.35871",
    seller_fee_basis_points: 200,
    sha256: "e13b5079ca7ff2f0e17bc29020557f252593b30f7f5c1ffc684992266701f9aa",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489975149,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 30,
    image: "ipfs://roam_llama_30.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_30.png",
      ipfs: "ipfs://roam_llama_30.png",
    },
    name: "roam_llama_30.png",
    rarity_per_mil: "8.78704",
    seller_fee_basis_points: 200,
    sha256: "67ab0fe682e1dce1e9673c323ae1af3f10073f01fac3cc1640e30806e4bfee04",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489979274,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 31,
    image: "ipfs://roam_llama_31.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_31.png",
      ipfs: "ipfs://roam_llama_31.png",
    },
    name: "roam_llama_31.png",
    rarity_per_mil: "36.55732",
    seller_fee_basis_points: 200,
    sha256: "a6e4310a71c139736ec441cd105d640a967711f2b5094cf06b1e5baaf6e3613d",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489983877,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 32,
    image: "ipfs://roam_llama_32.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_32.png",
      ipfs: "ipfs://roam_llama_32.png",
    },
    name: "roam_llama_32.png",
    rarity_per_mil: "17.92246",
    seller_fee_basis_points: 200,
    sha256: "7ec236210a38cec218e9987059cbae003c2a3f2a2402a925f35dc73c3767098b",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "5.60",
        trait_type: "eyepiece",
        value: "shades",
        weight: 4,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489988424,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 33,
    image: "ipfs://roam_llama_33.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_33.png",
      ipfs: "ipfs://roam_llama_33.png",
    },
    name: "roam_llama_33.png",
    rarity_per_mil: "2.72106",
    seller_fee_basis_points: 200,
    sha256: "5d698103d95c0180113031c84cfc098dc3bcf4d5d922d9e59a35d1236f16d355",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "5.60",
        trait_type: "earrings",
        value: "moonstars",
        weight: 3,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489992915,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 34,
    image: "ipfs://roam_llama_34.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_34.png",
      ipfs: "ipfs://roam_llama_34.png",
    },
    name: "roam_llama_34.png",
    rarity_per_mil: "2.09305",
    seller_fee_basis_points: 200,
    sha256: "24dbfba2776e4a03e02a254c16dccfc6b7fe1de93d3d89daabcd4794a9a1e6c3",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642489997278,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 35,
    image: "ipfs://roam_llama_35.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_35.png",
      ipfs: "ipfs://roam_llama_35.png",
    },
    name: "roam_llama_35.png",
    rarity_per_mil: "40.85970",
    seller_fee_basis_points: 200,
    sha256: "91561d9486243702bf9074701ea2a14cd21f0f8f4991720586f676f1573259f9",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490002506,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 36,
    image: "ipfs://roam_llama_36.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_36.png",
      ipfs: "ipfs://roam_llama_36.png",
    },
    name: "roam_llama_36.png",
    rarity_per_mil: "0.66538",
    seller_fee_basis_points: 200,
    sha256: "4337f63092dced07d485c4f1019fa9674374096ffa487bfa8ea49caa993e7a0a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490006727,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 37,
    image: "ipfs://roam_llama_37.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_37.png",
      ipfs: "ipfs://roam_llama_37.png",
    },
    name: "roam_llama_37.png",
    rarity_per_mil: "6.39159",
    seller_fee_basis_points: 200,
    sha256: "6fbb0bfda410d7ebd57cc3d3127c2ffcceb85c98577c947ec9b8b17607441d4b",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "3.30",
        trait_type: "headgear",
        value: "spacehelmet",
        weight: 3,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490011010,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 38,
    image: "ipfs://roam_llama_38.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_38.png",
      ipfs: "ipfs://roam_llama_38.png",
    },
    name: "roam_llama_38.png",
    rarity_per_mil: "2.74418",
    seller_fee_basis_points: 200,
    sha256: "339e97f8323f666c53dc46b1c25e50338771a2822a07c9c4f6316291c6f0e258",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490015974,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 39,
    image: "ipfs://roam_llama_39.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_39.png",
      ipfs: "ipfs://roam_llama_39.png",
    },
    name: "roam_llama_39.png",
    rarity_per_mil: "2.64860",
    seller_fee_basis_points: 200,
    sha256: "f782034e564447d64869b9fba86a4cd81b2b193cca05537fc1bb3f55cf3bf569",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490020468,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 40,
    image: "ipfs://roam_llama_40.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_40.png",
      ipfs: "ipfs://roam_llama_40.png",
    },
    name: "roam_llama_40.png",
    rarity_per_mil: "2.72134",
    seller_fee_basis_points: 200,
    sha256: "a22040f5344e932509a2e074bfb52da64bdf160b2fbf4f4651af8e58cd48a2d3",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490024619,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 41,
    image: "ipfs://roam_llama_41.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_41.png",
      ipfs: "ipfs://roam_llama_41.png",
    },
    name: "roam_llama_41.png",
    rarity_per_mil: "49.27715",
    seller_fee_basis_points: 200,
    sha256: "d4ce022c596782ade0fff51ecd905c42fe4917908c430008266529e339561ed6",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490031506,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 42,
    image: "ipfs://roam_llama_42.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_42.png",
      ipfs: "ipfs://roam_llama_42.png",
    },
    name: "roam_llama_42.png",
    rarity_per_mil: "8.04269",
    seller_fee_basis_points: 200,
    sha256: "f5daa0b820596ed42ee284f0ea584c8e286b3f407d253313bb93c828de5582d1",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490035994,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 43,
    image: "ipfs://roam_llama_43.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_43.png",
      ipfs: "ipfs://roam_llama_43.png",
    },
    name: "roam_llama_43.png",
    rarity_per_mil: "10.68235",
    seller_fee_basis_points: 200,
    sha256: "1365f6facb44f9ec7d6e19a47c6faba6a485c3a9e6386f3ebe15739abf0875a1",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490040451,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 44,
    image: "ipfs://roam_llama_44.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_44.png",
      ipfs: "ipfs://roam_llama_44.png",
    },
    name: "roam_llama_44.png",
    rarity_per_mil: "5.42378",
    seller_fee_basis_points: 200,
    sha256: "ef3bfa3f22f893d7c8771453da9cb1b0bb54b7ccd2a28aef6e50d46edb2f7734",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490047378,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 45,
    image: "ipfs://roam_llama_45.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_45.png",
      ipfs: "ipfs://roam_llama_45.png",
    },
    name: "roam_llama_45.png",
    rarity_per_mil: "0.77668",
    seller_fee_basis_points: 200,
    sha256: "4db0c4c6a4438fedb9f5209cadde283f1de663288dca014ede2e6d2b157608c8",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490051624,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 46,
    image: "ipfs://roam_llama_46.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_46.png",
      ipfs: "ipfs://roam_llama_46.png",
    },
    name: "roam_llama_46.png",
    rarity_per_mil: "6.47587",
    seller_fee_basis_points: 200,
    sha256: "339d103af5047775d795e34a04ef54fb79cdc612647d7ef35dfae08e06f8c461",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "5.60",
        trait_type: "earrings",
        value: "moonstars",
        weight: 3,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490055743,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 47,
    image: "ipfs://roam_llama_47.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_47.png",
      ipfs: "ipfs://roam_llama_47.png",
    },
    name: "roam_llama_47.png",
    rarity_per_mil: "1.62951",
    seller_fee_basis_points: 200,
    sha256: "f8a1abc5d860c5825825e3e4d87e97aafeca118ea01438166da6e258d3e4cfb2",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "3.40",
        trait_type: "earrings",
        value: "trees",
        weight: 2,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490060062,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 48,
    image: "ipfs://roam_llama_48.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_48.png",
      ipfs: "ipfs://roam_llama_48.png",
    },
    name: "roam_llama_48.png",
    rarity_per_mil: "4.94439",
    seller_fee_basis_points: 200,
    sha256: "5d9c2e5799cac7a085b07be294b13c474e3e58c2d31b76e38b7e16ee72dfd5e2",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "3.40",
        trait_type: "earrings",
        value: "trees",
        weight: 2,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490064474,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 49,
    image: "ipfs://roam_llama_49.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_49.png",
      ipfs: "ipfs://roam_llama_49.png",
    },
    name: "roam_llama_49.png",
    rarity_per_mil: "0.90672",
    seller_fee_basis_points: 200,
    sha256: "ea2f2d9f8d4ea87e24f26c9634436c6b9abc276ccae33cd849dea2c71b40da2c",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490068673,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 50,
    image: "ipfs://roam_llama_50.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_50.png",
      ipfs: "ipfs://roam_llama_50.png",
    },
    name: "roam_llama_50.png",
    rarity_per_mil: "11.12143",
    seller_fee_basis_points: 200,
    sha256: "b7302442898f0772388bebf3e54bd558073e5ee4b9230aaaf7d9daebabd0cb84",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490073105,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 51,
    image: "ipfs://roam_llama_51.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_51.png",
      ipfs: "ipfs://roam_llama_51.png",
    },
    name: "roam_llama_51.png",
    rarity_per_mil: "4.01201",
    seller_fee_basis_points: 200,
    sha256: "49bc0d5c44c901057d9b61c9c6b4ee8a8fe1848a0f851d691d48fe418328c2cd",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490077506,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 52,
    image: "ipfs://roam_llama_52.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_52.png",
      ipfs: "ipfs://roam_llama_52.png",
    },
    name: "roam_llama_52.png",
    rarity_per_mil: "49.80498",
    seller_fee_basis_points: 200,
    sha256: "d5fe83bf8a3593000f3cb5a890af54a941896aa59748ea1b2be4cf3fdde04e57",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490083991,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 53,
    image: "ipfs://roam_llama_53.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_53.png",
      ipfs: "ipfs://roam_llama_53.png",
    },
    name: "roam_llama_53.png",
    rarity_per_mil: "12.28644",
    seller_fee_basis_points: 200,
    sha256: "022989e02ce2cbb67114ad0f2f4897595ea3e251a45138f7c383e0c79fe45acb",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "5.60",
        trait_type: "earrings",
        value: "moonstars",
        weight: 3,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490088354,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 54,
    image: "ipfs://roam_llama_54.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_54.png",
      ipfs: "ipfs://roam_llama_54.png",
    },
    name: "roam_llama_54.png",
    rarity_per_mil: "2.46601",
    seller_fee_basis_points: 200,
    sha256: "1772a6b38eb3a9b6897d23f4ff8256d332836375db4ce4f1aaa9b7b753ec5ca2",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490093403,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 55,
    image: "ipfs://roam_llama_55.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_55.png",
      ipfs: "ipfs://roam_llama_55.png",
    },
    name: "roam_llama_55.png",
    rarity_per_mil: "35.75834",
    seller_fee_basis_points: 200,
    sha256: "f99e31dcfbb5973a122a1a7c7adc2d61b2a16be58693d2e7d5f491a3e87e3932",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490098421,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 56,
    image: "ipfs://roam_llama_56.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_56.png",
      ipfs: "ipfs://roam_llama_56.png",
    },
    name: "roam_llama_56.png",
    rarity_per_mil: "1.42773",
    seller_fee_basis_points: 200,
    sha256: "222e6f871b550a4f2a923bdf8b818e678fb4677699c3d9b0f0b03ac4e487b1e0",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490102623,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 57,
    image: "ipfs://roam_llama_57.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_57.png",
      ipfs: "ipfs://roam_llama_57.png",
    },
    name: "roam_llama_57.png",
    rarity_per_mil: "12.30172",
    seller_fee_basis_points: 200,
    sha256: "2443e1986a871cb9e054bca63e0a486ebb2c9cf7a2b8683e196ad10f11c9e037",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490107222,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 58,
    image: "ipfs://roam_llama_58.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_58.png",
      ipfs: "ipfs://roam_llama_58.png",
    },
    name: "roam_llama_58.png",
    rarity_per_mil: "15.42013",
    seller_fee_basis_points: 200,
    sha256: "0c3c1202d5d1dc68b68d9debaa9869a910c3195ccbbb15fac5a5dbbf2e6e4391",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490111604,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 59,
    image: "ipfs://roam_llama_59.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_59.png",
      ipfs: "ipfs://roam_llama_59.png",
    },
    name: "roam_llama_59.png",
    rarity_per_mil: "32.37686",
    seller_fee_basis_points: 200,
    sha256: "9bd9274d0cd32ae04a0a2a6c262f89c777e9a89dfbee1f33443d08e360cc8124",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490115804,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 60,
    image: "ipfs://roam_llama_60.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_60.png",
      ipfs: "ipfs://roam_llama_60.png",
    },
    name: "roam_llama_60.png",
    rarity_per_mil: "1.78638",
    seller_fee_basis_points: 200,
    sha256: "f4a1c07a444890a8edf74755ba27b147f30096c5c420b463d835a52edba82d38",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490122400,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 61,
    image: "ipfs://roam_llama_61.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_61.png",
      ipfs: "ipfs://roam_llama_61.png",
    },
    name: "roam_llama_61.png",
    rarity_per_mil: "32.94627",
    seller_fee_basis_points: 200,
    sha256: "9337b879d4c1eb362263ba7bd31ef72f797c6d47fdb735e75aa173be231db932",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490127288,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 62,
    image: "ipfs://roam_llama_62.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_62.png",
      ipfs: "ipfs://roam_llama_62.png",
    },
    name: "roam_llama_62.png",
    rarity_per_mil: "15.06144",
    seller_fee_basis_points: 200,
    sha256: "fe218734e0b99ca794b4c968fe58594c3ce9d38b1e34b9f30a7b9399b3b01b82",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490131513,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 63,
    image: "ipfs://roam_llama_63.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_63.png",
      ipfs: "ipfs://roam_llama_63.png",
    },
    name: "roam_llama_63.png",
    rarity_per_mil: "6.81536",
    seller_fee_basis_points: 200,
    sha256: "e07557f5d24e0b4de3b92a41ed3104337e5d423b6d0c0a71ac395e202d9b2407",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490135825,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 64,
    image: "ipfs://roam_llama_64.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_64.png",
      ipfs: "ipfs://roam_llama_64.png",
    },
    name: "roam_llama_64.png",
    rarity_per_mil: "0.84944",
    seller_fee_basis_points: 200,
    sha256: "9c192cf1b1c5057ec4432ac828d9300139d377649d2cd3c6b4055d2cea1d4d16",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490142828,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 65,
    image: "ipfs://roam_llama_65.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_65.png",
      ipfs: "ipfs://roam_llama_65.png",
    },
    name: "roam_llama_65.png",
    rarity_per_mil: "10.98753",
    seller_fee_basis_points: 200,
    sha256: "683c235a8996dcdd8737166a8e0120b915b703c586884eedd058559e7a7d6d41",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490147505,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 66,
    image: "ipfs://roam_llama_66.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_66.png",
      ipfs: "ipfs://roam_llama_66.png",
    },
    name: "roam_llama_66.png",
    rarity_per_mil: "29.16910",
    seller_fee_basis_points: 200,
    sha256: "6e2de96a7dd6da7eb4ccea98398e2feee811c77eb26084e018f4b1010aca9669",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490151889,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 67,
    image: "ipfs://roam_llama_67.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_67.png",
      ipfs: "ipfs://roam_llama_67.png",
    },
    name: "roam_llama_67.png",
    rarity_per_mil: "1.87128",
    seller_fee_basis_points: 200,
    sha256: "8a145cb7cd5af26b967e0b786c4259f16c8669d73942ec0a4bbc640306eee46a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490156868,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 68,
    image: "ipfs://roam_llama_68.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_68.png",
      ipfs: "ipfs://roam_llama_68.png",
    },
    name: "roam_llama_68.png",
    rarity_per_mil: "3.46613",
    seller_fee_basis_points: 200,
    sha256: "a1f55a0358c4d95b887e531c75e0c283ad381aa125cacb0269d75f508e9fb438",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "7.70",
        trait_type: "neckwear",
        value: "jewels",
        weight: 5,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490161300,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 69,
    image: "ipfs://roam_llama_69.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_69.png",
      ipfs: "ipfs://roam_llama_69.png",
    },
    name: "roam_llama_69.png",
    rarity_per_mil: "18.23483",
    seller_fee_basis_points: 200,
    sha256: "b619e9c6d653134693f50422ba327cd2002f9335e6e690214bb42f9370adc9ed",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "5.60",
        trait_type: "eyepiece",
        value: "shades",
        weight: 4,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490165784,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 70,
    image: "ipfs://roam_llama_70.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_70.png",
      ipfs: "ipfs://roam_llama_70.png",
    },
    name: "roam_llama_70.png",
    rarity_per_mil: "3.01431",
    seller_fee_basis_points: 200,
    sha256: "046d6fa1bdce752d965fd04529b5043902a0b0ab410855f6de75304452b89b96",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490170328,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 71,
    image: "ipfs://roam_llama_71.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_71.png",
      ipfs: "ipfs://roam_llama_71.png",
    },
    name: "roam_llama_71.png",
    rarity_per_mil: "3.10049",
    seller_fee_basis_points: 200,
    sha256: "fe4d348d527df222039302277bb0fc8eae12ec3c355d88f35d974a7263874410",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490174672,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 72,
    image: "ipfs://roam_llama_72.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_72.png",
      ipfs: "ipfs://roam_llama_72.png",
    },
    name: "roam_llama_72.png",
    rarity_per_mil: "25.53276",
    seller_fee_basis_points: 200,
    sha256: "9b615f394d261214d4fa92d9c9d9cd414a9a985fb1149994d3e8f5431f8353ce",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490178960,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 73,
    image: "ipfs://roam_llama_73.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_73.png",
      ipfs: "ipfs://roam_llama_73.png",
    },
    name: "roam_llama_73.png",
    rarity_per_mil: "12.88609",
    seller_fee_basis_points: 200,
    sha256: "dcf044b976faecb9437f1a57fa8db40cca9d70c6eb55159e4daf6ab27cc86286",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490183460,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 74,
    image: "ipfs://roam_llama_74.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_74.png",
      ipfs: "ipfs://roam_llama_74.png",
    },
    name: "roam_llama_74.png",
    rarity_per_mil: "18.10288",
    seller_fee_basis_points: 200,
    sha256: "6ebcc7dbe884716ed6543b6312ebe1f9041934ec3bed1507cb4aab12a9ef6237",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490187749,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 75,
    image: "ipfs://roam_llama_75.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_75.png",
      ipfs: "ipfs://roam_llama_75.png",
    },
    name: "roam_llama_75.png",
    rarity_per_mil: "49.52596",
    seller_fee_basis_points: 200,
    sha256: "e02d8b53b7a0baa0462d9201926398d049c614bb5ecb1eecf964c1667fcd17a5",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "6.10",
        trait_type: "mouth",
        value: "tongue",
        weight: 5,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490192293,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 76,
    image: "ipfs://roam_llama_76.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_76.png",
      ipfs: "ipfs://roam_llama_76.png",
    },
    name: "roam_llama_76.png",
    rarity_per_mil: "13.23721",
    seller_fee_basis_points: 200,
    sha256: "a8ee0952e5188729946ed7d21af3cee4013250295e3c5799f5d0be513786c494",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490196849,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 77,
    image: "ipfs://roam_llama_77.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_77.png",
      ipfs: "ipfs://roam_llama_77.png",
    },
    name: "roam_llama_77.png",
    rarity_per_mil: "4.75237",
    seller_fee_basis_points: 200,
    sha256: "d448ab586622a0c6a8b9f96922f53d71cd10cf8b26a1eed6f66f2a80339306b6",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490201534,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 78,
    image: "ipfs://roam_llama_78.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_78.png",
      ipfs: "ipfs://roam_llama_78.png",
    },
    name: "roam_llama_78.png",
    rarity_per_mil: "1.11833",
    seller_fee_basis_points: 200,
    sha256: "56dfd51db858bdce9aa2169d48479fd98b35f3242bd2c68b0058eee845997d79",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490206043,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 79,
    image: "ipfs://roam_llama_79.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_79.png",
      ipfs: "ipfs://roam_llama_79.png",
    },
    name: "roam_llama_79.png",
    rarity_per_mil: "7.74060",
    seller_fee_basis_points: 200,
    sha256: "56c825632bf4aadbc3a50c73673d3b664fa06002bef92ca83decd93f5e2c9cbb",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490213192,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 80,
    image: "ipfs://roam_llama_80.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_80.png",
      ipfs: "ipfs://roam_llama_80.png",
    },
    name: "roam_llama_80.png",
    rarity_per_mil: "9.64861",
    seller_fee_basis_points: 200,
    sha256: "dfd8dcc6ce504f96898f7f60fe3a15d78dc339320e97c58b6d2d4a681ab406d0",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "5.60",
        trait_type: "eyepiece",
        value: "shades",
        weight: 4,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490220088,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 81,
    image: "ipfs://roam_llama_81.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_81.png",
      ipfs: "ipfs://roam_llama_81.png",
    },
    name: "roam_llama_81.png",
    rarity_per_mil: "8.16722",
    seller_fee_basis_points: 200,
    sha256: "4e86a5e011ebe01a460d978830485eb325dc202a27bfbf1365bfb7b156eaa18a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490224637,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 82,
    image: "ipfs://roam_llama_82.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_82.png",
      ipfs: "ipfs://roam_llama_82.png",
    },
    name: "roam_llama_82.png",
    rarity_per_mil: "6.92583",
    seller_fee_basis_points: 200,
    sha256: "eca6c63501c69583d48ba7fdecd44c5e43422ae3d8cb8643b107ba71fcc6b8cb",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490229909,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 83,
    image: "ipfs://roam_llama_83.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_83.png",
      ipfs: "ipfs://roam_llama_83.png",
    },
    name: "roam_llama_83.png",
    rarity_per_mil: "1.52013",
    seller_fee_basis_points: 200,
    sha256: "f550f4f972da07ab83559c4052784071ff251a5970801a87e0858596005dbd32",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490237567,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 84,
    image: "ipfs://roam_llama_84.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_84.png",
      ipfs: "ipfs://roam_llama_84.png",
    },
    name: "roam_llama_84.png",
    rarity_per_mil: "5.07148",
    seller_fee_basis_points: 200,
    sha256: "af431a6442d1259f85d34eebfb8715727121c105155c02863d6f2663193fd409",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "10.90",
        trait_type: "mouth",
        value: "grin",
        weight: 8,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "7.70",
        trait_type: "eyepiece",
        value: "shutters",
        weight: 5,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490245343,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 85,
    image: "ipfs://roam_llama_85.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_85.png",
      ipfs: "ipfs://roam_llama_85.png",
    },
    name: "roam_llama_85.png",
    rarity_per_mil: "4.19594",
    seller_fee_basis_points: 200,
    sha256: "cf41b68d922489864fa0debce94d464edd1d4f84b2dcfd576723955c20fb2bb8",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "3.30",
        trait_type: "headgear",
        value: "spacehelmet",
        weight: 3,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490253333,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 86,
    image: "ipfs://roam_llama_86.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_86.png",
      ipfs: "ipfs://roam_llama_86.png",
    },
    name: "roam_llama_86.png",
    rarity_per_mil: "7.45490",
    seller_fee_basis_points: 200,
    sha256: "0e6a35934f8e24b84f47e626187a456f0dd6b155bc851120cf5abe2aad8b194b",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "14.70",
        trait_type: "coat",
        value: "downy",
        weight: 12,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490258259,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 87,
    image: "ipfs://roam_llama_87.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_87.png",
      ipfs: "ipfs://roam_llama_87.png",
    },
    name: "roam_llama_87.png",
    rarity_per_mil: "3.47504",
    seller_fee_basis_points: 200,
    sha256: "d8f1d8f854e8036914176b7d2522be9512bec87814684fc375fb5a7725759e19",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "9.30",
        trait_type: "background",
        value: "unicorn",
        weight: 9,
      },
      {
        rarity_pct: "9.00",
        trait_type: "coat",
        value: "chestnut",
        weight: 8,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490263150,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 88,
    image: "ipfs://roam_llama_88.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_88.png",
      ipfs: "ipfs://roam_llama_88.png",
    },
    name: "roam_llama_88.png",
    rarity_per_mil: "7.61603",
    seller_fee_basis_points: 200,
    sha256: "5a19e5df79efd3fafa4b2743a8bd3fee675dab8517a610a14f2cd9a7ac3d250c",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "18.20",
        trait_type: "headgear",
        value: "camocap",
        weight: 13,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490271197,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 89,
    image: "ipfs://roam_llama_89.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_89.png",
      ipfs: "ipfs://roam_llama_89.png",
    },
    name: "roam_llama_89.png",
    rarity_per_mil: "221.85516",
    seller_fee_basis_points: 200,
    sha256: "330f57bdc8ba5ae36de5ee8844badd384e59fce253b868cb95c22b4c841b0fa6",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490276854,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 90,
    image: "ipfs://roam_llama_90.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_90.png",
      ipfs: "ipfs://roam_llama_90.png",
    },
    name: "roam_llama_90.png",
    rarity_per_mil: "7.33987",
    seller_fee_basis_points: 200,
    sha256: "8aaffb320a555b2e2288e706d4b988cd37c9acc7dcbf2d74de4495686f6b0f47",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490281415,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 91,
    image: "ipfs://roam_llama_91.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_91.png",
      ipfs: "ipfs://roam_llama_91.png",
    },
    name: "roam_llama_91.png",
    rarity_per_mil: "1.61317",
    seller_fee_basis_points: 200,
    sha256: "dcb6c6aacf42e410eda9e14d2a36f4260a3bfaa9c7e57a234399e511b121bcec",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "11.20",
        trait_type: "neckwear",
        value: "tassels",
        weight: 7,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "4.30",
        trait_type: "eyepiece",
        value: "patch",
        weight: 3,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490288931,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 92,
    image: "ipfs://roam_llama_92.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_92.png",
      ipfs: "ipfs://roam_llama_92.png",
    },
    name: "roam_llama_92.png",
    rarity_per_mil: "1.68658",
    seller_fee_basis_points: 200,
    sha256: "f5966a7b927ed43362fd19b1fa06d329f9aacbd4e4e8ed816110ab6a0394d6ff",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "20.30",
        trait_type: "coat",
        value: "tuscany",
        weight: 17,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490296689,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 93,
    image: "ipfs://roam_llama_93.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_93.png",
      ipfs: "ipfs://roam_llama_93.png",
    },
    name: "roam_llama_93.png",
    rarity_per_mil: "29.71965",
    seller_fee_basis_points: 200,
    sha256: "b7c793fc8234a5b1f918451a5ac242459bbb05d6cf8a1ae94466b977344c98f1",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "16.30",
        trait_type: "background",
        value: "blue",
        weight: 15,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "15.10",
        trait_type: "neckwear",
        value: "scarf",
        weight: 10,
      },
      {
        rarity_pct: "11.80",
        trait_type: "mouth",
        value: "shock",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "17.40",
        trait_type: "eyepiece",
        value: "fashionista",
        weight: 12,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490301407,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 94,
    image: "ipfs://roam_llama_94.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_94.png",
      ipfs: "ipfs://roam_llama_94.png",
    },
    name: "roam_llama_94.png",
    rarity_per_mil: "3.92910",
    seller_fee_basis_points: 200,
    sha256: "75fb3d0de15cd2799ee27da82264c4d1186849ce80314308d14e9feb73eaeb42",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "5.90",
        trait_type: "headgear",
        value: "roamcap",
        weight: 5,
      },
      {
        rarity_pct: "43.30",
        trait_type: "earrings",
        value: "empty",
        weight: 26,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490306205,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 95,
    image: "ipfs://roam_llama_95.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_95.png",
      ipfs: "ipfs://roam_llama_95.png",
    },
    name: "roam_llama_95.png",
    rarity_per_mil: "4.66524",
    seller_fee_basis_points: 200,
    sha256: "bc5d98bf739115c4f56455e47a3c8fecdc093dff2691f7132f8edd59a886c00a",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "22.60",
        trait_type: "background",
        value: "gray",
        weight: 20,
      },
      {
        rarity_pct: "8.70",
        trait_type: "coat",
        value: "fuchsia",
        weight: 7,
      },
      {
        rarity_pct: "16.10",
        trait_type: "neckwear",
        value: "rags",
        weight: 12,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "10.50",
        trait_type: "eyepiece",
        value: "aviators",
        weight: 7,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "punk",
        weight: 10,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490311326,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 96,
    image: "ipfs://roam_llama_96.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_96.png",
      ipfs: "ipfs://roam_llama_96.png",
    },
    name: "roam_llama_96.png",
    rarity_per_mil: "5.02893",
    seller_fee_basis_points: 200,
    sha256: "f3d0b5ac33ed922c5d951c1cce695d083edfb5c5d55cf969203738a50910d9f7",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "13.30",
        trait_type: "background",
        value: "orange",
        weight: 13,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "13.10",
        trait_type: "mouth",
        value: "surprised",
        weight: 10,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "15.70",
        trait_type: "eyepiece",
        value: "googles",
        weight: 10,
      },
      {
        rarity_pct: "13.40",
        trait_type: "headgear",
        value: "tophat",
        weight: 10,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490316464,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 97,
    image: "ipfs://roam_llama_97.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_97.png",
      ipfs: "ipfs://roam_llama_97.png",
    },
    name: "roam_llama_97.png",
    rarity_per_mil: "2.79923",
    seller_fee_basis_points: 200,
    sha256: "7057423192c8778c116fdb42c24213da00bcfe07ab1826d62acb5d9e5ecf20d6",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "11.90",
        trait_type: "background",
        value: "purple",
        weight: 10,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "36.30",
        trait_type: "neckwear",
        value: "empty",
        weight: 28,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "17.40",
        trait_type: "headgear",
        value: "straw",
        weight: 15,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490321106,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 98,
    image: "ipfs://roam_llama_98.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_98.png",
      ipfs: "ipfs://roam_llama_98.png",
    },
    name: "roam_llama_98.png",
    rarity_per_mil: "51.08356",
    seller_fee_basis_points: 200,
    sha256: "4b3c54c0011399c661e3ad2c76fc66848b9585d5ca49d8b81f7444bb9c87f41d",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "8.00",
        trait_type: "background",
        value: "seascape",
        weight: 7,
      },
      {
        rarity_pct: "13.40",
        trait_type: "coat",
        value: "laser",
        weight: 10,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "26.40",
        trait_type: "mouth",
        value: "smile",
        weight: 20,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "11.40",
        trait_type: "headgear",
        value: "camhelm",
        weight: 8,
      },
      {
        rarity_pct: "16.30",
        trait_type: "earrings",
        value: "flowers",
        weight: 9,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490326944,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 99,
    image: "ipfs://roam_llama_99.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_99.png",
      ipfs: "ipfs://roam_llama_99.png",
    },
    name: "roam_llama_99.png",
    rarity_per_mil: "2.77499",
    seller_fee_basis_points: 200,
    sha256: "0974ac7c3a4b299e1e26891d5218b98b8c4988c10831865cbdc3ba5089a4a654",
    symbol: "ROAM",
    type: "image/png",
  },
  {
    attributes: [
      {
        rarity_pct: "18.60",
        trait_type: "background",
        value: "green",
        weight: 16,
      },
      {
        rarity_pct: "33.90",
        trait_type: "coat",
        value: "white",
        weight: 30,
      },
      {
        rarity_pct: "13.60",
        trait_type: "neckwear",
        value: "leis",
        weight: 8,
      },
      {
        rarity_pct: "31.70",
        trait_type: "mouth",
        value: "neutral",
        weight: 24,
      },
      {
        rarity_pct: "100.00",
        trait_type: "eyes",
        value: "black",
        weight: 100,
      },
      {
        rarity_pct: "38.80",
        trait_type: "eyepiece",
        value: "empty",
        weight: 24,
      },
      {
        rarity_pct: "30.40",
        trait_type: "headgear",
        value: "empty",
        weight: 22,
      },
      {
        rarity_pct: "15.70",
        trait_type: "earrings",
        value: "tassels",
        weight: 8,
      },
    ],
    author: "roampool.com",
    category: "image",
    create_date: 1642490336009,
    creators: [
      {
        ownership: 100,
        stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
      },
    ],
    description: "Unique Llamas NFT from ROAM.",
    id: 100,
    image: "ipfs://roam_llama_100.png",
    location: {
      https: "https://roampool.com/llamas/images/roam_llama_100.png",
      ipfs: "ipfs://roam_llama_100.png",
    },
    name: "roam_llama_100.png",
    rarity_per_mil: "50.34030",
    seller_fee_basis_points: 200,
    sha256: "ca94ac8ee272aaa746cd3ca3b4a6547f6295fc470ddc655b1ea5a1844008010f",
    symbol: "ROAM",
    type: "image/png",
  },
]

export const nfts = raw.splice(0, 100)
// this is a hack with release dates, move it to json or somewhere nice
nfts[0].release_date = moment("01-25-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[0].creators = [
  {
    ownership: 100,
    stake_address: "stake1u8zy8cj3377rtpjdc2u8kg8mxg9mc62tq97t2l2pa3f2w7s9ag8l3",
  },
]
nfts[1].release_date = moment("02-03-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[1].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyehqlrquteenk4ur5w7kg835g50536ktjaw8cc3msgnkgqewurzh",
  },
]
nfts[2].release_date = moment("02-09-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[2].creators = [
  {
    ownership: 100,
    stake_address: "stake1ux0mf8uxuf679pwjy05kmykwmpvjrmwtv7mvns9lr0wtjdqewgf7z",
  },
]
nfts[3].release_date = moment("02-14-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[3].creators = [
  {
    ownership: 100,
    stake_address: "stake1u89lav2h9m4msncdfkagz6mwrjuwuwd2k7lrm3teg3576aq2ckvtq",
  },
]
nfts[4].release_date = moment("02-14-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[4].creators = [
  {
    ownership: 100,
    stake_address: "stake1uxjf3q6j3valv7hfvaz72rt9nw69ee07exs9vec6hycq3pq6aynyv",
  },
]
nfts[5].release_date = moment("02-27-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[5].creators = [
  {
    ownership: 100,
    stake_address: "stake1u9tdc4x9tf64ac445e5t7zvklnes5fecr60m8ld5lyrehmg4eascx",
  },
]
nfts[6].release_date = moment("04-02-2022 11:40 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[6].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyhk9yysld7hqh35eczsjgrfvaa4500uerhehnr7m4ter7ck7g0gt",
  },
]
nfts[7].release_date = moment("04-02-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[7].creators = [
  {
    ownership: 100,
    stake_address: "stake1u8fk5uqe7yfyzlm45t5wkuyd03vytq6ys39u6942z0ay7uqvyruxe",
  },
]
nfts[8].release_date = moment("05-02-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[8].creators = [
  {
    ownership: 100,
    stake_address: "stake1uydth0nrx0fqgt7vzurywd0hwnzrw34xzt5u69l3k7wwmvqcexhm8",
  },
]
nfts[9].release_date = moment("05-03-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[9].creators = [
  {
    ownership: 100,
    stake_address: "stake1u89lav2h9m4msncdfkagz6mwrjuwuwd2k7lrm3teg3576aq2ckvtq",
  },
]
nfts[10].release_date = moment("05-21-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[10].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyt4v56aszyl7p3gmrpm8d6ah2jtclazgr8skz3vfqm8vdcltszjx",
  },
]
nfts[11].release_date = moment("05-21-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[11].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyadmnpu537qq43jc7gqg8usq0l7wv70n2vun3xjnzqz6dsp2kwva",
  },
]
nfts[12].release_date = moment("05-21-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[12].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyhk9yysld7hqh35eczsjgrfvaa4500uerhehnr7m4ter7ck7g0gt",
  },
]
nfts[13].release_date = moment("07-05-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[13].creators = [
  {
    ownership: 100,
    stake_address: "stake1u87vvtthe9f7we4ujxg8d6lst67sshqnvnvln97uzat5njgsne3q5",
  },
]
nfts[14].release_date = moment("07-05-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[14].creators = [
  {
    ownership: 100,
    stake_address: "stake1u824v4r0jrpuuzaq2j4mjssx3r4q77lkuhgrwh7x4gv5k3qjdj6du",
  },
]
nfts[15].release_date = moment("07-16-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[15].creators = [
  {
    ownership: 100,
    stake_address: "stake1u835urwt2chz3grvqw6wlpjz4xefuqvx7l6w57vswr6mdjsj5vrmj",
  },
]
nfts[16].release_date = moment("08-02-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[16].creators = [
  {
    ownership: 100,
    stake_address: "stake1u824v4r0jrpuuzaq2j4mjssx3r4q77lkuhgrwh7x4gv5k3qjdj6du",
  },
]
nfts[17].release_date = moment("08-15-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[17].creators = [
  {
    ownership: 100,
    stake_address: "stake1uyt4v56aszyl7p3gmrpm8d6ah2jtclazgr8skz3vfqm8vdcltszjx",
  },
]
nfts[18].release_date = moment("08-15-2022 11:41 PM", "MM-DD-YYYY hh:mm A").valueOf()
nfts[18].creators = [
  {
    ownership: 100,
    stake_address: "stake1u9tdc4x9tf64ac445e5t7zvklnes5fecr60m8ld5lyrehmg4eascx",
  },
]

export const teammates: Member[] = [
  {
    role: "Co-Founder",
    image: "https://roampool.com/jason-style.jpg",
    name: "Jason SUN",
    twitter: "https://twitter.com/sunapi386",
    linkedin: "https://www.linkedin.com/in/sunapi386/",
    description:
      "Stay hungry stay foolish. Write the story for our future generations. During covid-19, I" +
      " caught the travel bug. That's how my roam journey started.",
  },
  {
    role: "Co-Founder ",
    image: "https://roampool.com/douby-style.jpg",
    name: "Kun (Douby) QIU",
    description:
      "A free roamer that loves nature and a simple life. A believer in the path for decentralization. If" +
      " you spot me in the wild, call me a roamer!",
  },
]
